import AnalyticsContext from '@root/core/src/contexts/analytics/analytics-context';
import AnalyticsService from '@root/core/src/services/analytics-service';
import { useContext, useEffect } from '@root/vendor/react';

export default function useContentTagPageViewEvents(analyticsTag, pageTitle) {
  const { eventPrefix } = useContext(AnalyticsContext);

  useEffect(() => {
    if (!analyticsTag) { return; }

    const normalizedTag = AnalyticsService.normalizeForAnalyticsContext(analyticsTag);
    const normalizedTitle = AnalyticsService.normalizeForAnalyticsContext(pageTitle);
    const context = `${normalizedTag}_${normalizedTitle}`;

    AnalyticsService.trackViewEvent(context, { eventPrefix });
  }, [analyticsTag, eventPrefix, pageTitle]);
}
